import { Component, Input } from '@angular/core';
import { PriceCardPriceComponent } from 'projects/shared/lib/components/shared/price/card-price/price-card-price.component';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';

@Component({
  selector: 'app-price-card-price',
  templateUrl: './price-card-price.component.html',
  standalone: false
})
export class PriceCardPriceMHComponent extends PriceCardPriceComponent {

  @Input() shouldAllowTextWrap: boolean | undefined;

  private permissionSubscription: Subscription | undefined;

  public ngOnInit(): void {
    super.ngOnInit();

    this.permissionSubscriptionInit();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();

    this.permissionSubscription?.unsubscribe();
  }

  private permissionSubscriptionInit() {
    if (!this.permissionSubscription) {
      this.permissionSubscription = this.authService.userPermissionChangedGet().subscribe(
        () => {
          this.shouldDisplayPrices = this.shouldDisplayPricesCurrentStateGet();
        }
      );
    }
  }

  protected shouldDisplayPricesCurrentStateGet(): boolean | undefined {
    return ENVIRONMENT.price.allowAnonymousPrice || (this.authService.isAuthenticated() && this.authService?.canSeePrices());
  }

}